// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3y6LC","bigColWidth":"Table_bigColWidth__ZTekM","biggerColWidth":"Table_biggerColWidth__1nqZ-","row":"Table_row__ErPGt","col":"Table_col__kD1bP"};